// components
import Navbar from 'components/Navbar';
import LayoutWrapper from 'containers/LayoutWrapper';
import AddClass from 'pages/AddClass';
import AddStudents from 'pages/AddStudents';
import Classes from 'pages/Classes';
import Dashboard from 'pages/Dashboard';
import Overview from 'pages/Dashboard/Subpages/Overview';
import Ticket from 'pages/Dashboard/Subpages/Ticket';
import ManageClass from 'pages/ManageClass';
import ManageUser from 'pages/ManageUser';
import ResetPassword from 'pages/ResetPassword';
import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { OVERVIEW_FULL, routes } from './routes';

const NavLayout = () => (
  <div className="navbar-layout">
    <Navbar />
    <Outlet />
  </div>
);

const ClassroomLayout = () => (
  <div className="navbar-layout">
    <Navbar title="Manage Classes" classroomList={false} />
    <Outlet />
  </div>
);

const App = () => (
  <div className="app-container">
    <Routes>
      <Route path="/" element={<Navigate to={OVERVIEW_FULL} />} />
      <Route element={<NavLayout />}>
        <Route element={<LayoutWrapper />}>
          <Route path={routes.DASHBOARD} element={<Dashboard />}>
            <Route path={routes.OVERVIEW} element={<Overview />} />
            <Route path={routes.TICKET} element={<Ticket />} />
          </Route>
        </Route>
      </Route>

      <Route element={<LayoutWrapper overlay="secondary" />}>
        <Route path={routes.ADD_CLASS} element={<AddClass />} />
        <Route path={routes.ADD_STUDENTS} element={<AddStudents />} />
      </Route>

      <Route element={<ClassroomLayout overlay="secondary" />}>
        <Route element={<LayoutWrapper overlay="secondary" />}>
          <Route path={routes.CLASSES} element={<Classes />} />
          <Route path={routes.MANAGE_CLASS} element={<ManageClass />} />
          <Route path={routes.RESET_ALL_PASSWORDS} element={<ResetPassword resetAll />} />
          <Route path={routes.RESET_USER_PASSWORD} element={<ResetPassword />} />
          <Route path={routes.MANAGE_USER} element={<ManageUser />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  </div>
);

export default App;
